import numeral from 'numeral';

export const DEFAULT_FORMAT = '0.00';

const formatNumber = (
  input, // input number
  conversion, // conversion function
  format = DEFAULT_FORMAT // numeral format string
) => numeral(conversion ? conversion(input) : input).format(format);

export default formatNumber;

export const truncateNumber = number => {
  if (typeof number !== 'number') {
    return '';
  }
  return number > 1000 ? number.toFixed(0) : number.toFixed(3);
};
